 
import styled from '@emotion/styled';

interface PaginatorProps {
  totalPages: number;
  currentPage: number;
  className?: string;
}

const PaginatorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.spacing(1)};
  width: 100%;
`;

const Indicator = styled.div<{ isActive: boolean }>`
  ${(props) =>
    props.isActive
      ? `
    width: 16px;
    height: 8px;
    background: ${props.theme.colors.primary[1000]};
    border-radius: 100px;
  `
      : `
    width: 8px;
    height: 8px;
    background: ${props.theme.colors.neutral.white};
    border-radius: 50%;
  `}
  transition: all 0.3s ease;
`;

export const Paginator = ({ totalPages, currentPage, className }: PaginatorProps) => {
  // Ensure currentPage is within valid range
  const validCurrentPage = Math.max(1, Math.min(currentPage, totalPages));

  return (
    <PaginatorContainer className={className}>
      {Array.from({ length: totalPages }, (_, index) => {
        const pageNumber = index + 1;
        return <Indicator key={pageNumber} isActive={pageNumber === validCurrentPage} />;
      })}
    </PaginatorContainer>
  );
};
